// CRO Cart Drawer v2 — Four Sigmatic exact match (inline qty, no popup)
(function(){
  if (window.__CRO_CART_LOADED__) return;
  window.__CRO_CART_LOADED__ = true;

  // === COUPON — update these to match the top-bar banner ===
var COUPON_CODE  = 'INSDIWALI';          // active discount code shown in cart strip (FREEDOM, ends 2026-08-31)
var COUPON_LABEL = 'Diwali Sale · 10% off above ₹499';
var COUPON_MIN   = 499;               // cart minimum in Rs for the code (0 = none) — must match the price rule
var DEAL_PRODUCT_IDS = [];  // Deal of the Day products the code excludes (must match the price rule's exclusion)
var DEAL_UNTIL       = '2026-10-03T23:59:59+05:30'; // after this the exclusion note switches itself off
  // =========================================================

  function moneyFormat(cents){
    if (window.croMoney) return window.croMoney(cents); // CX 2026-10-03: shared formatter (theme.liquid)
    var rs = cents / 100;
    return 'Rs. ' + rs.toLocaleString('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2});
  }
  // Shopify's /discount/{code} never rejects a code — a cart under the minimum just gets no discount
  // at checkout. So the strip checks the minimum itself and says how much more to add.
  // Shopify checks the minimum on prices BEFORE the code's own discount (cart.js lines are after it),
  // and Deal of the Day items get no discount and don't count toward the minimum.
  function isDeal(item){
    return DEAL_PRODUCT_IDS.indexOf(item.product_id) > -1 && Date.now() <= Date.parse(DEAL_UNTIL);
  }
  function cartCents(cart, deal){
    return ((cart && cart.items) || []).reduce(function(sum, item){
      return isDeal(item) === deal ? sum + item.original_line_price : sum;
    }, 0);
  }
  function dealCents(cart){ return cartCents(cart, true); }
  function couponShortBy(cart){
    if (!COUPON_MIN || !cart) return 0;
    return Math.max(0, COUPON_MIN * 100 - cartCents(cart, false));
  }
  var ICON_ALERT = '<span class="cro-cart__coupon-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg></span>';
  var ICON_CHECK = '<span class="cro-cart__coupon-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>';
  // State of the strip once the code is tapped/applied: {cls, html}
  function couponState(code, cart){
    var deal = dealCents(cart);
    if (deal && !cartCents(cart, false)) {
      return {cls: 'cro-cart__coupon--short', html: ICON_ALERT + '<span class="cro-cart__coupon-text"><strong>' + code + '</strong> can\'t be combined with the Deal of the Day price · Add other items to use it</span>'};
    }
    var short = couponShortBy(cart);
    var dealNote = deal ? ' (Deal of the Day items don\'t count)' : '';
    if (short) {
      return {cls: 'cro-cart__coupon--short', html: ICON_ALERT + '<span class="cro-cart__coupon-text"><strong>' + code + '</strong> works on orders of ' + moneyFormat(COUPON_MIN * 100) + ' or more' + dealNote + ' · Add ' + moneyFormat(short) + ' more to unlock it</span>'};
    }
    return {cls: 'cro-cart__coupon--applied', html: ICON_CHECK + '<span class="cro-cart__coupon-text"><strong>' + code + '</strong> applied · ' + (deal ? 'Not combinable with the Deal of the Day, so it applies to your other items' : 'Discount shown at checkout') + '</span>'};
  }
  function truncateName(name){
    var words = name.split(/[\s|]+/).filter(Boolean);
    return words.slice(0, 3).join(' ');
  }
  async function getCart(){
    try {
      var r = await fetch('/cart.js', {headers: {Accept: 'application/json'}});
      return await r.json();
    } catch(e) { return null; }
  }
  async function updateQty(line, qty){
    try {
      var r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({line: line, quantity: qty}),
      });
      return await r.json();
    } catch(e) { return null; }
  }
  async function getRecommendations(productId, limit){
    if (!productId) return [];
    try {
      var r = await fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + (limit||6) + '&intent=related');
      var data = await r.json();
      return data.products || [];
    } catch(e) { return []; }
  }

  function buildDrawer(cart, recs){
    var totalCents = cart.total_price;
    var html = '';

    // Header
    html += '<div class="cro-cart__header">';
    html += '<div class="cro-cart__title">';
    html += '<svg class="cro-cart__title-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
    html += 'Your Cart<span class="cro-cart__count">' + (cart.item_count || 0) + '</span>';
    html += '</div>';
    html += '<button type="button" class="cro-cart__close" aria-label="Close" onclick="document.querySelector(\'cart-drawer\').classList.remove(\'active\');"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';
    html += '</div>';

    // Coupon strip (tap to apply) — only rendered when a coupon code is configured above
    var couponApplied = COUPON_CODE && (document.cookie || '').includes('discount_code=' + COUPON_CODE);
    var couponNow = couponApplied && couponState(COUPON_CODE, cart);
    if (COUPON_CODE) {
    html += '<div class="cro-cart__coupon ' + (couponNow ? couponNow.cls : '') + '" data-code="' + COUPON_CODE + '">';
    if (couponNow) {
      html += couponNow.html;
    } else {
      html += '<span class="cro-cart__coupon-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12a2 2 0 0 1 0-4V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v2a2 2 0 0 1 0 4v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="15" x2="15.01" y2="15"/><line x1="9" y1="15" x2="15" y2="9"/></svg></span>';
      html += '<span class="cro-cart__coupon-text">' + COUPON_LABEL + ' — Tap to apply <strong>' + COUPON_CODE + '</strong></span>';
      html += '<button type="button" class="cro-cart__coupon-cta">APPLY</button>';
    }
    html += '</div>';
    }

    // Trust bar (always show, regardless of cart state)
    html += '<div class="cro-cart__trustbar">';
    html += '<span class="cro-cart__trustbar-pill cro-cart__trustbar-pill--ship"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Free Shipping Unlocked</span>';
    html += '</div>';

    // Items
    html += '<div class="cro-cart__items">';
    if (cart.items && cart.items.length) {
      cart.items.forEach(function(item, idx){
        var fullName = item.product_title || item.title;
        var shortName = truncateName(fullName);
        var hasMore = shortName !== fullName && fullName.length > shortName.length + 2;
        var variantName = item.variant_title || '';
        var hasCompare = item.original_price > item.final_price;
        var line = idx + 1;
        html += '<div class="cro-cart__item" data-line="' + line + '">';
        html += '<img class="cro-cart__item-img" src="' + (item.image || (item.featured_image && item.featured_image.url)) + '" alt="">';
        html += '<div class="cro-cart__item-meta">';
        html += '<div class="cro-cart__item-title"><span class="cro-cart__item-title-short">' + shortName + (hasMore ? '...' : '') + '</span>';
        if (hasMore) {
          html += '<button type="button" class="cro-cart__item-title-toggle">More</button>';
          html += '<span class="cro-cart__item-title-full" style="display:none">' + fullName + '</span>';
        }
        html += '</div>';
        if (variantName && variantName !== 'Default Title') {
          html += '<div class="cro-cart__item-variant">' + variantName + '</div>';
        }
        html += '<div class="cro-cart__item-price">';
        html += '<span class="cro-cart__item-price-sale">' + moneyFormat(item.final_price) + '</span>';
        if (hasCompare) html += '<span class="cro-cart__item-price-strike">' + moneyFormat(item.original_price) + '</span>';
        html += '</div>';
        // BWA delivery tag — hidden by default, revealed only when BWA confirms this variant
        html += '<div class="cro-cart__item-bwa-delivery" data-vid="' + item.variant_id + '" style="display:none">';
        html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
        html += '<span>Delivered by Amazon</span>';
        html += '</div>';
        html += '</div>';
        // Right column: inline qty + remove
        html += '<div class="cro-cart__item-actions">';
        html += '<div class="cro-cart__qty">';
        html += '<button type="button" class="cro-cart__qty-btn" data-action="decrease" data-line="' + line + '" aria-label="Decrease quantity">−</button>';
        html += '<span class="cro-cart__qty-value">' + item.quantity + '</span>';
        html += '<button type="button" class="cro-cart__qty-btn" data-action="increase" data-line="' + line + '" aria-label="Increase quantity">+</button>';
        html += '</div>';
        html += '<button type="button" class="cro-cart__remove" aria-label="Remove" data-line="' + line + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg></button>';
        html += '</div>';
        html += '</div>';
      });
    } else {
      html += '<div style="text-align:center;padding:48px 0;color:#8b6e52;">Your cart is empty</div>';
    }
    html += '</div>';

    // Customers Also Bought
    if (recs && recs.length) {
      html += '<div class="cro-cart__rec">';
      html += '<div class="cro-cart__rec-title">Customers Also Bought</div>';
      html += '<button type="button" class="cro-cart__rec-arrow cro-cart__rec-arrow--prev cro-cart__rec-arrow--hidden" aria-label="Previous"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>';
      html += '<button type="button" class="cro-cart__rec-arrow cro-cart__rec-arrow--next" aria-label="Next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></button>';
      html += '<div class="cro-cart__rec-scroll">';
      recs.forEach(function(p){
        var name = truncateName(p.title);
        var img = p.featured_image || (p.images && p.images[0]);
        // Get first available variant id for direct ATC
        var firstVariant = (p.variants && p.variants[0]) ? p.variants[0].id : null;
        html += '<div class="cro-cart__rec-item">';
        html += '<a href="' + p.url + '" class="cro-cart__rec-link">';
        html += '<img class="cro-cart__rec-img" src="' + img + '" alt="">';
        html += '<div class="cro-cart__rec-name">' + name + '</div>';
        html += '<div class="cro-cart__rec-price">' + moneyFormat(p.price) + '</div>';
        html += '</a>';
        if (firstVariant) {
          html += '<button type="button" class="cro-cart__rec-add" data-variant-id="' + firstVariant + '">Add to Cart</button>';
        } else {
          html += '<a href="' + p.url + '" class="cro-cart__rec-add">View</a>';
        }
        html += '</div>';
      });
      html += '</div></div>';
    }

    // Sticky footer
    if (cart.items && cart.items.length) {
      var totalCompare = 0;
      cart.items.forEach(function(i){ totalCompare += i.original_price * i.quantity; });
      var showCompare = totalCompare > totalCents;
      html += '<div class="cro-cart__footer">';
      html += '<a href="/checkout" class="cro-cart__checkout">';
      html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>';
      html += '<span>SECURE CHECKOUT</span>';
      html += '<span class="cro-cart__checkout-prices">·<span>' + moneyFormat(totalCents) + '</span>';
      if (showCompare) html += '<span class="cro-cart__checkout-strike">' + moneyFormat(totalCompare) + '</span>';
      html += '</span>';
      html += '</a>';
      html += '<div class="cro-cart__trust"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>10-day money-back guarantee</div>';
      html += '</div>';
    }

    return html;
  }

  async function renderDrawer(){
    var drawer = document.querySelector('cart-drawer .drawer__inner');
    if (!drawer) return;
    var cart = await getCart();
    if (!cart) return;
    var recs = [];
    if (cart.items && cart.items.length) {
      recs = await getRecommendations(cart.items[0].product_id, 8);
    }
    var existing = drawer.querySelector('.cro-cart');
    var html = buildDrawer(cart, recs);
    if (existing) existing.innerHTML = html;
    else {
      var wrap = document.createElement('div');
      wrap.className = 'cro-cart';
      wrap.innerHTML = html;
      drawer.appendChild(wrap);
    }
    wireDrawer();
    setupBwaItemListener();
    fitCheckout();
  }

  // Keep "SECURE CHECKOUT · Rs. X  ~Rs. Y~" on ONE line: step the font down until it fits the button
  // (long prices / discount strike-through on narrow phones used to wrap every part onto 2 lines).
  function fitCheckout(){
    document.querySelectorAll('.cro-cart__checkout').forEach(function(btn){
      btn.style.fontSize = '';
      if (!btn.clientWidth) return; // hidden drawer — re-fitted on next render
      var size = parseFloat(getComputedStyle(btn).fontSize);
      while (btn.scrollWidth > btn.clientWidth && size > 10) {
        size -= 0.5;
        btn.style.fontSize = size + 'px';
      }
    });
  }
  window.addEventListener('resize', fitCheckout);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitCheckout);

  // Check BWA's own injection — if BWA has rendered a delivery pill for a variant_id, show our tag for that item
  function setupBwaItemListener(){
    function checkBwaVariants(){
      document.querySelectorAll('.cro-cart__item-bwa-delivery[data-vid]').forEach(function(slot){
        var vid = slot.dataset.vid;
        var bwaInjection = document.querySelector('[id*="bwa-cart"][id*="' + vid + '"], [id*="buywithamazon"][id*="' + vid + '"]');
        if (bwaInjection) {
          slot.style.setProperty('display', 'inline-flex', 'important');
        } else if (slot.style.display !== 'inline-flex') {
          slot.style.setProperty('display', 'none', 'important');
        }
      });
    }
    // Run multiple times — BWA injects async, can take up to 10s
    [500, 1500, 3000, 5000, 8000, 12000].forEach(function(ms){ setTimeout(checkBwaVariants, ms); });
    // MutationObserver — catches BWA injections in real time
    if (window.__croCartBwaObserver) return;
    window.__croCartBwaObserver = new MutationObserver(function(muts){
      var hasBwa = muts.some(function(m){
        return Array.from(m.addedNodes || []).some(function(n){
          return typeof n.id === 'string' && (n.id.indexOf('bwa-cart') >= 0 || n.id.indexOf('buywithamazon') >= 0);
        });
      });
      if (hasBwa) checkBwaVariants();
    });
    window.__croCartBwaObserver.observe(document.body, {childList: true, subtree: true});
  }

  function wireDrawer(){
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.querySelectorAll('.cro-cart__item-title-toggle').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var item = btn.closest('.cro-cart__item');
        var sh = item.querySelector('.cro-cart__item-title-short');
        var fu = item.querySelector('.cro-cart__item-title-full');
        if (sh.style.display === 'none') {
          sh.style.display = '';
          fu.style.display = 'none';
          btn.textContent = 'More';
        } else {
          sh.style.display = 'none';
          fu.style.display = '';
          btn.textContent = 'Less';
        }
      });
    });
    // Inline qty − / +
    drawer.querySelectorAll('.cro-cart__qty-btn').forEach(function(btn){
      btn.addEventListener('click', async function(e){
        e.preventDefault();
        var line = parseInt(btn.dataset.line, 10);
        var action = btn.dataset.action;
        var cart = await getCart();
        var item = cart.items[line-1];
        if (!item) return;
        var newQty = action === 'increase' ? item.quantity + 1 : Math.max(0, item.quantity - 1);
        await updateQty(line, newQty);
        renderDrawer();
      });
    });
    drawer.querySelectorAll('.cro-cart__remove').forEach(function(btn){
      btn.addEventListener('click', async function(){
        var line = parseInt(btn.dataset.line, 10);
        await updateQty(line, 0);
        renderDrawer();
      });
    });
    // Carousel arrows + conditional visibility based on scroll position
    var scroll = drawer.querySelector('.cro-cart__rec-scroll');
    var prevBtn = drawer.querySelector('.cro-cart__rec-arrow--prev');
    var nextBtn = drawer.querySelector('.cro-cart__rec-arrow--next');
    if (scroll && prevBtn && nextBtn) {
      var updateArrows = function(){
        var atStart = scroll.scrollLeft < 5;
        var atEnd = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 5;
        prevBtn.classList.toggle('cro-cart__rec-arrow--hidden', atStart);
        nextBtn.classList.toggle('cro-cart__rec-arrow--hidden', atEnd);
      };
      scroll.addEventListener('scroll', updateArrows);
      prevBtn.addEventListener('click', function(){ scroll.scrollBy({left: -260, behavior: 'smooth'}); });
      nextBtn.addEventListener('click', function(){ scroll.scrollBy({left: 260, behavior: 'smooth'}); });
      setTimeout(updateArrows, 100);
    }
    // Recommendation Add to Cart buttons — quick-add without leaving page
    drawer.querySelectorAll('.cro-cart__rec-add[data-variant-id]').forEach(function(btn){
      btn.addEventListener('click', async function(e){
        e.preventDefault();
        e.stopPropagation();
        if (btn.dataset.added === '1') return;
        var vid = parseInt(btn.dataset.variantId, 10);
        if (!vid) return;
        var orig = btn.textContent;
        btn.textContent = 'Adding...';
        btn.disabled = true;
        try {
          await fetch('/cart/add.js', {
            method: 'POST', credentials: 'include',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({id: vid, quantity: 1}),
          });
          btn.textContent = '✓ Added';
          btn.dataset.added = '1';
          btn.classList.add('cro-cart__rec-add--added');
          // Re-render after a short pause so the user sees the "Added" state
          setTimeout(function(){ renderDrawer(); }, 800);
        } catch(err) {
          btn.textContent = orig;
          btn.disabled = false;
        }
      });
    });
  }

  function init(){
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    // Intercept all cart link clicks
    document.addEventListener('click', function(e){
      var link = e.target.closest('a[href$="/cart"], a[href="/cart"], a.header-cart-link, .cro-dh-cart');
      if (!link) return;
      var d = document.querySelector('cart-drawer');
      if (!d) return;
      e.preventDefault();
      e.stopPropagation();
      d.classList.add('active');
      renderDrawer();
    }, true);
    // Coupon tap-to-apply (delegation — works across re-renders)
    document.addEventListener('click', function(e){
      var coupon = e.target.closest('.cro-cart__coupon:not(.cro-cart__coupon--applied)');
      if (!coupon) return;
      e.preventDefault();
      e.stopPropagation();
      var code = coupon.dataset.code;
      if (!code) return;
      console.log('[CRO Cart] Applying coupon:', code);
      fetch('/discount/' + encodeURIComponent(code), {credentials: 'include', method: 'GET'})
        .catch(function(err){ console.log('[CRO Cart] discount fetch err:', err); })
        .then(getCart)
        .then(function(cart){
          var s = couponState(code, cart);
          coupon.classList.remove('cro-cart__coupon--short', 'cro-cart__coupon--applied');
          coupon.classList.add(s.cls);
          coupon.innerHTML = s.html;
        });
    });
    // Re-render on drawer open
    var observer = new MutationObserver(function(){
      if (drawer.classList.contains('active') || drawer.classList.contains('is-open')) {
        renderDrawer();
      }
    });
    observer.observe(drawer, {attributes: true, attributeFilter: ['class']});
    document.addEventListener('cart:refresh', renderDrawer);
    document.addEventListener('cart:updated', renderDrawer);
    renderDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
